import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { safeLocalStorage } from '~/store/safeLocalStorage'
import { IAddress } from '~/types'

interface SmartAccountOrderState {
  orderByOrg: Record<string, IAddress[]>
  setOrder: (orgId: string, order: IAddress[]) => void
}

/**
 * Persists the value-ordered account list per org so accounts render in last
 * session's order while balances are still loading, instead of re-shuffling
 * once they arrive.
 */
export const useSmartAccountOrderStore = create<SmartAccountOrderState>()(
  persist(
    (set) => ({
      orderByOrg: {},
      setOrder: (orgId, order) =>
        set((state) => ({
          orderByOrg: { ...state.orderByOrg, [orgId]: order },
        })),
    }),
    {
      name: 'smart-account-order',
      storage: safeLocalStorage,
      version: 1,
    },
  ),
)
